import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_validateCache = new ThunderDispatcher('__validateCache');
//# sourceMappingURL=dispatchers.js.map